import { BettoEmptyState } from "@pages/profile-v2/betto/components/BettoEmptyState";
import { isBettoHistoryTenant } from "@pages/profile-v2/betto/shared/bettoHistoryStyles";
import React from "react";
import NoContentIcon from "../../../../assets/icons/NoContent.jsx";
import {
	NoContentDescription,
	NoContentIconWrapper,
	NoContentTitle,
	NoContentWrapper,
} from "./elements.js";

const NoContent = ({ title, description, translate, noBackground }) => {
	if (isBettoHistoryTenant) {
		return <BettoEmptyState title={translate(description || title)} />;
	}

	return (
		<NoContentWrapper noBackground={noBackground}>
			<NoContentIconWrapper>
				<NoContentIcon />
			</NoContentIconWrapper>
			<NoContentTitle>{translate(title)}</NoContentTitle>
			<NoContentDescription>{translate(description)}</NoContentDescription>
		</NoContentWrapper>
	);
};

export default NoContent;
